import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/warehouse-list`)
  return data.data
}

export const useWarehouseWarehouses = () => {
  const { data, ...props } = useQuery(
    queryKeys.WAREHOUSE_WAREHOUSES,
    () => getData(),
  )
  return { data, ...props }
}
